// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KhlK","largestCol":"styles_largestCol__1IMzE","smallestCol":"styles_smallestCol__-JJ6T"};